import type { ReactNode } from 'react';

import {
  LanguageCode,
  MarketCode,
} from '@silvertours/common-landingpages-view';

import * as String from '../../strings';
import { Anchor, Text } from './PhoneNumber.styles';

type PhoneNumberProps = {
  className?: string;
  phoneNumber: string;
  language: LanguageCode;
  market?: MarketCode;
  icon?: ReactNode;
  hidePhoneNumber?: boolean;
};

const PhoneNumber = ({
  className,
  phoneNumber,
  language,
  market,
  icon,
  hidePhoneNumber,
}: PhoneNumberProps) => {
  const pn = String.parsePhoneNumber(phoneNumber, language);
  const displayNumber = market === 'CH' ? pn.international : pn.national;
  const showText = !hidePhoneNumber && !!displayNumber;

  return (
    <Anchor
      className={className}
      href={pn.url}
      target="_system"
      $showText={showText}
    >
      {icon}
      <Text $showText={showText}>{displayNumber}</Text>
    </Anchor>
  );
};

export { PhoneNumber };
